// Adapted for STATIC favicons.
// This repo's index.html references flat favicon files (no theme subdir), e.g.
//   ./img/favicons/favicon-32x32.png, favicon-16x16.png, apple-touch-icon.png
// and a root favicon.ico. This util rewrites those hrefs to the /stonerebrand/
// variants using a filename map. It is idempotent (safe to call multiple times).

const KNOWN_FAVICON_FILES = [
  'android-chrome-192x192.png',
  'android-chrome-512x512.png',
  'apple-touch-icon.png',
  'favicon-16x16.png',
  'favicon-32x32.png',
  'favicon.ico'
]

const STONE_REBRAND_DIR = './img/favicons/stonerebrand/'

function basename (href) {
  if (!href) return ''
  // strip query/hash, then take the last path segment
  const clean = href.split('#')[0].split('?')[0]
  const parts = clean.split('/')
  return parts[parts.length - 1]
}

export function applyStoneRebrandFavicon () {
  if (typeof document === 'undefined') return

  const links = document.querySelectorAll(
    "link[rel~='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']"
  )

  links.forEach(function (link) {
    const href = link.getAttribute('href')
    if (!href) return

    // already pointing at the rebrand dir -> idempotent no-op
    if (href.indexOf('/stonerebrand/') !== -1) return

    const file = basename(href)
    if (KNOWN_FAVICON_FILES.indexOf(file) === -1) return

    link.setAttribute('href', STONE_REBRAND_DIR + file)
  })
}

export default applyStoneRebrandFavicon
